import React from 'react';

// const SliderArrow = ({className}) => (
//   <div className={className}/>
// );

class SliderArrow extends React.Component {
  render() {

    return (
      <div className={`ic ${this.props.icon} ${this.props.className}`} onClick={this.props.onClick}/>
    );
  }
}

export default SliderArrow;



// WEBPACK FOOTER //
// ./js/components/global/SliderArrow.js